import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FileDetails } from '../../models/attachment';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpEventType, HttpHeaders, HttpResponse } from '@angular/common/http';
import { catchError, last, map, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Globals } from '../../service/global';
import { AttachmentDataSource } from 'src/app/service/attachment.datasource';
import { NotifierService } from 'angular-notifier';
import { environment, environment_const, environment_msg } from 'src/environments/environment';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { PreviewAttachmentComponent } from '../preview-attachment/preview-attachment.component';
import { NgxSpinnerService } from 'ngx-spinner';

export interface attachmentData {
  sno: string;
  filename: string;
  filetype: string;
  size: string;
  delete: string;
  existing : boolean;
}

const ELEMENT_DATA: attachmentData[] = [
  {sno: '1', filename: 'Jikan flow', filetype: 'pdf', size: '5 mb', delete: 'delete_forever',existing : false},
  {sno: '2', filename: 'Jikan_latest', filetype: 'zip', size: '10 mb', delete: 'delete_forever',existing : false},
  {sno: '3', filename: 'Jikan_Mock', filetype: 'zip', size: '20 mb', delete: 'delete_forever',existing : true}
];
@Component({
  selector: 'app-attachment-dialog',
  templateUrl: './attachment-dialog.component.html',
  styleUrls: ['./attachment-dialog.component.css']
})
export class AttachmentDialogComponent implements OnInit {
  displayedColumns: string[] = ['filename', 'filetype', 'size' ,'delete'];
  //dataSource!: MatTableDataSource<attachmentData>;
  private readonly notifier!: NotifierService;
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;

  conAttachmentDel:any
  attachmentData : any
  loaded = 0;
  selectedFiles!: FileList;
  uploadedFiles: FileDetails[] = [];
  showProgress = false;
  listReqJSON:any;
  fileDataSource!: AttachmentDataSource;
  blobresp: any;
  attachmentUrl: any;
  responsevalue: any;
  spinner : any = false;
  disableAttachmentFileIcon: any;
  data?:any;
  constructor(public meetingService : MeetingService,public sideNav:SideNavServiceService, public dialog : MatDialog, private dialogRef: MatDialogRef<AttachmentDialogComponent>,public attachService:AttachmentService, @Inject(MAT_DIALOG_DATA) data:any,private snackBar: MatSnackBar,notifierService: NotifierService,private spin: NgxSpinnerService) { 
    //  const attachementData = Array.from({length: 10}, (_, k) => createNewAttachment(k + 1));
    this.attachmentData = data;
    this.notifier = notifierService;
    // // Assign the data to the data source for the table to render
     //this.dataSource = new MatTableDataSource(ELEMENT_DATA);
     this.listReqJSON =
    {
      "orgCode": "CHN",
      "idisplayStart": 0,
      "idisplayLength": 5,
      "fkEntityId":data.e.entityId,
      "attachmentEntityType":data.e.entityType,
      "attachmentMode":"FI"
    }
    
    if($("#commonMomStatusCode").val()!=undefined && $("#commonMomStatusCode").val()!=null && $("#commonMomStatusCode").val()==environment_const.momApproveStatus){
      this.sideNav.disablePageAfterApproval();
     }
  }

  ngAfterViewInit() {
    

    if(this.attachmentData.disaleAttachmentFileIcon == true){
      this.disableAttachmentFileIcon = this.attachmentData.disaleAttachmentFileIcon;
    }else{
      this.disableAttachmentFileIcon = this.attachmentData.disaleAttachmentFileIcon;
    }

    //this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;
    
    this.fileDataSource.counter$
    .pipe(
      tap((count) => {
        this.paginator.length = count;
        //this.isLoading = true;
      })
    )
    .subscribe();
  this.paginator.page
    .pipe(
      tap(() => this.loadAttachmentList())
    )
    .subscribe(); 

}
loadAttachmentList() {
  this.listReqJSON.idisplayStart=this.paginator.pageIndex;
  this.listReqJSON.idisplayLength=this.paginator.pageSize;
  this.fileDataSource.loadAttachmentList(this.listReqJSON);
}
  
  

  ngOnInit(): void {
    this.fileDataSource = new AttachmentDataSource(this.attachService);
    this.listReqJSON.idisplayStart = 0;
    this.listReqJSON.idisplayLength = 5;
    
    
    this.listReqJSON.attachmentEntityType=this.attachmentData.m;
    switch ( this.listReqJSON.attachmentEntityType) {
      case environment.noteEntityType:
        this.listReqJSON.fkEntityId=this.attachmentData.e.noteId;
          break;
      case environment.decisionEntityType:
        this.listReqJSON.fkEntityId=this.attachmentData.e.decisionId;
          break;
      case environment.taskEntityType:
        if(this.attachmentData.e.isFollowUpFlag=='Y'){
          this.listReqJSON.fkEntityId=this.attachmentData.e.followUpTaskInfo.taskId;
        }else{
          this.listReqJSON.fkEntityId=this.attachmentData.e.taskId;
        }
          break;
      default:
        this.listReqJSON.fkEntityId=this.attachmentData.e.agendaId;
          break;
    }
    this.listReqJSON.attachmentMode="FI";
   let resp = this.fileDataSource.loadAttachmentList(this.listReqJSON);
   
  }

  // displayedColumns: string[] = ['sno', 'filename', 'filetype', 'size', 'delete'];
  // dataSource = ELEMENT_DATA;
  selectFile(event:any) {
    this.selectedFiles = event.target.files;
    
  }
  upload(entityInfo:any,entityType:any) {
    this.showProgress = true;
    this.uploadedFiles = [];
    this.spinner = true;
    if(entityInfo!=null && entityInfo.isFollowUpFlag=="Y"){
      entityInfo.meetingId=entityInfo.followUpTaskInfo.meetingId;
      entityInfo.taskId=entityInfo.followUpTaskInfo.taskId;
    }
    if(this.selectedFiles != undefined && this.selectedFiles != null && this.selectedFiles.length != undefined && this.selectedFiles.length != 0 ){
      Array.from(this.selectedFiles).forEach(file => {
      const fileDetails = new FileDetails();
      fileDetails.name = file.name;
      var size=file.size/1024;
        this.data=file;
      this.uploadedFiles.push(fileDetails);
      
      
      this.attachService.uploadSingleFile(file,entityInfo,entityType)
        .pipe(tap(event => {
          if (event.type === HttpEventType.UploadProgress) {
            if (event.total) {  
                const total: number = event.total;
                let totalSize = event.total/1000;
                if(totalSize<=200000){
                fileDetails.progress = Math.round(100 * event.loaded / total);    
                //
                let file = document.getElementById("fileUpload");
                
                }else{
                  this.spinner = false;
                  this.notifier.show({
                    type: 'error',
                    message: environment_msg.msg_error_user_attachment_filesize_exceeded
                  });                 
                }
                
            }   
            else {  
                //handle illegal state  
               //
               this.notifier.show({
                type: 'error',
                message: 'Unable to upload some file(s)'
              });
              this.spinner = false;
            }
         }
        })).subscribe((event:any) => {
         
        if (event instanceof HttpResponse) {
          if (this.selectedFiles.item(this.selectedFiles.length - 1) === file) {
            // Invokes fetchFileNames() when last file in the list is uploaded.
            //this.attachService.fetchFileNames();
            //Need to refresh data table
            this.loadAttachmentList();
            this.notifier.show({
              type: 'success',
              message: 'Attachment added successfully'
            });
            this.spinner = false;
            document.getElementById("resetbtn")?.click()
          }
        }
      },
      err => {
        
      });
    });
  }else{
    this.spinner = false;
    this.notifier.show({
      type: 'error',
      message: 'Please Select the Attachment'
    });
  }
  }

  resetAttachment(event : any) { 
    this.selectedFiles = event.target.files;
  }

  deleteAttachment(attachmentId:any){
    //
    this.dialog.open(ConfirmDialogComponent, {
      data: {
        dialogTitle : "Confirmation",
        dialogContent : environment_msg.msg_confirm_delete_attachment
      },
    }).afterClosed().subscribe(response => {
      this.conAttachmentDel = response

      if(this.conAttachmentDel){
    this.attachService.deleteAttachment(attachmentId).subscribe(res => {
      if (res != null ) {
       
        this.notifier.show({
          type: 'success',
          message: 'Deleted Successfully'
        });
        this.loadAttachmentList();
      }
    });
  }
  });
  }

  // downloadAttachfile(fileName:any){
  
  //   const a = document.createElement('a');
  //   document.body.appendChild(a);
  //   const blob = new Blob([fileName], { type: 'text/plain' }),
  //     url = window.URL.createObjectURL(blob);
  
  //   if (navigator.appVersion.toString().indexOf('.NET') > 0 && window.navigator.msSaveBlob) {
  
  //     let val = window.navigator.msSaveBlob(blob, fileName + '.txt');
  
  //   }
  //   else {
  //     a.href = url;
  //     a.download = fileName  + '.txt';
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //   }
  // }

  getAttachfile(fileId:any,title:any,type:any){
    
    const attchDialog = this.dialog.open(PreviewAttachmentComponent, {
              data: {
                "fileId": fileId,
                "title": title,
                "type": type
              },
              panelClass: ['animate__animated', 'animate__slideInLeft'],
              disableClose: true,
              position: {
                left: "0%"
              },
              maxWidth: "100%",
              maxHeight: "100vh",
              width: "100%",
              height: "100vh"
            })
    
  }
  closeDialog(){
    this.dialogRef.close();
  }
}
